export default "__VITE_ASSET__sRMoy$At__"